import { render } from "./UnitManagement.vue?vue&type=template&id=55e6cbee&scoped=true"
import script from "./UnitManagement.vue?vue&type=script&lang=js"
export * from "./UnitManagement.vue?vue&type=script&lang=js"

import "./UnitManagement.vue?vue&type=style&index=0&id=55e6cbee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e6cbee"]])

export default __exports__